import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { LoaderService } from 'src/app/components/loader/service/loader.service';
import { Sector } from 'src/app/shared/interfaces/sector.interface';
import { SectorService } from '../sector.service';

@Component({
  selector: 'app-sector-list',
  templateUrl: './sector-list.component.html',
  styleUrls: ['./sector-list.component.css'],
})
export class SectorListComponent implements OnInit {
  constructor(
    private sectorService: SectorService,
    private toatsr: ToastrService,
    private Router: Router,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private loadService: LoaderService
  ) {}

  displayedColumns: string[] = ['position', 'name', 'leader', 'actions'];
  dataSource = new MatTableDataSource<Sector>();
  searchValue = '';
  sectors: Sector[] = [];
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.loadSectors();
  }

  loadSectors(): Promise<any> {
    this.loadService.showLoader();
    return this.sectorService
      .get()
      .then((res) => {
        this.sectors = res;
        this.loadService.closeLoader();
      })
      .catch((err) => {
        this.toatsr.error(err.error.message);
        this.loadService.closeLoader();
      });
  }

  search(searchValue: string): Promise<any> {
    return this.sectorService
      .searchSector(searchValue)
      .then((res) => {
        this.sectors = res;
      })
      .catch((err) => {
        this.toatsr.error(err.error.message || 'Falha na busca');
      });
  }

  openEdit(id: number) {
    this.Router.navigateByUrl('/setor/' + id);
  }

  delete(id: number, name: string): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      height: '250px',
      data: {
        title: 'Excluir',
        text: ' Deseja remover a célula ? ',
        name: name,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.sectorService
          .deleteSector(id)
          .then((res: any) => {
            this.snackBar.open(res.message, null, {
              duration: 4000,
            });
            this.dataSource = new MatTableDataSource<Sector>();
            this.loadSectors();
          })
          .catch((err: any) => {
            this.snackBar.open(err.error.message || 'Algo de errado aconteçeu');
          });
      }
    });
  }
}
